export const DaysBetweenDates = (wkStart, wkEnd) => {
  var dia_actual = wkStart;
  var fechas = [];
  while (dia_actual.isSameOrBefore(wkEnd)) {
    fechas.push(dia_actual.format('DD-MM-YYYY'));
    dia_actual.add(1, 'days');
  }
  return fechas;
};
